import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import ServiceMonitorCard from './service-monitor-card';
import ServiceMonitorDialog from './service-monitor-dialog'; // api

import { getSystemDataSource, getSystemDataProcessing, getSystemTrafficModelTrainer, getSystemTrafficModelPrediction, getSystemMonitorPortalHealthChecks, getSystemMonitorAppHealthChecks, getSystemMonitorWebSiteHealthChecks, getSystemOpenAPIHealth } from '../../api/systemHealthCheckAPI';
var t = i18n.getFixedT(null, 'setting-service');
var ServiceMonitor = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var dispatch = useDispatch();

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      dialogData = _useState2[0],
      setDialogData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      dataSource = _useState4[0],
      setDataSource = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      dataProcessing = _useState6[0],
      setDataProcessing = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      trafficModelTrainer = _useState8[0],
      setTrafficModelTrainer = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      trafficModelPrediction = _useState10[0],
      setTrafficModelPrediction = _useState10[1];

  var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      portalHealthChecks = _useState12[0],
      setPortalHealthChecks = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      appHealthChecks = _useState14[0],
      setAppHealthChecks = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      webSiteHealthChecks = _useState16[0],
      setWebSiteHealthChecks = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      openAPIHealth = _useState18[0],
      setOpenAPIHealth = _useState18[1];

  var serviceAry = ['dataSource', 'dataProcessing', 'trafficModelTrainer', 'trafficModelPrediction', 'portalHealthChecks', 'appHealthChecks', 'webSiteHealthChecks', 'openAPIHealth'];
  useEffect(function () {
    // get dataSource
    getSystemDataSource(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setDataSource(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setDataSource(newData);
    }); // get dataProcessing

    getSystemDataProcessing(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setDataProcessing(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setDataProcessing(newData);
    }); // get trafficModelTrainer

    getSystemTrafficModelTrainer(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setTrafficModelTrainer(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setTrafficModelTrainer(newData);
    }); // get trafficModelPrediction

    getSystemTrafficModelPrediction(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setTrafficModelPrediction(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setTrafficModelPrediction(newData);
    }); // get systemMonitorPortalHealthChecks

    getSystemMonitorPortalHealthChecks(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setPortalHealthChecks(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setPortalHealthChecks(newData);
    }); // getSystemMonitorAppHealthChecks

    getSystemMonitorAppHealthChecks(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setAppHealthChecks(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setAppHealthChecks(newData);
    }); // getSystemMonitorWebSiteHealthChecks

    getSystemMonitorWebSiteHealthChecks(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setWebSiteHealthChecks(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setWebSiteHealthChecks(newData);
    }); // get open api health

    getSystemOpenAPIHealth(contextRoot, true).then(function (result) {
      var newData = _objectSpread({
        'fetchStatus': 'complete'
      }, result.value);

      setOpenAPIHealth(newData);
    }).catch(function (error) {
      var newData = {
        'fetchStatus': 'error'
      };
      setOpenAPIHealth(newData);
    });
    return function () {
      setDataSource(null);
      setDataProcessing(null);
      setTrafficModelTrainer(null);
      setTrafficModelPrediction(null);
      setPortalHealthChecks(null);
      setAppHealthChecks(null);
      setWebSiteHealthChecks(null);
    };
  }, []);

  var handleOpenDialog = function handleOpenDialog(data) {
    setDialogData(data);
  };

  var handleCloseDialog = function handleCloseDialog() {
    setDialogData({});
  };

  var renderServiceMoitorCard = function renderServiceMoitorCard() {
    return _.map(serviceAry, function (item) {
      var data = {
        fetchStatus: 'loading',
        title: ''
      };

      switch (item) {
        case 'dataSource':
          data.title = t('lbl-data-source-plat');
          if (dataSource) data = _objectSpread(_objectSpread({}, data), dataSource);
          break;

        case 'dataProcessing':
          data.title = t('lbl-data-processing-plat');
          if (dataProcessing) data = _objectSpread(_objectSpread({}, data), dataProcessing);
          break;

        case 'trafficModelTrainer':
          data.title = t('lbl-traffic-trainer');
          if (trafficModelTrainer) data = _objectSpread(_objectSpread({}, data), trafficModelTrainer);
          break;

        case 'trafficModelPrediction':
          data.title = t('lbl-traffic-prediction');
          if (trafficModelPrediction) data = _objectSpread(_objectSpread({}, data), trafficModelPrediction);
          break;

        case 'portalHealthChecks':
          data.title = t('lbl-portal-health-checks');
          if (portalHealthChecks) data = _objectSpread(_objectSpread({}, data), portalHealthChecks);
          break;

        case 'appHealthChecks':
          data.title = t('lbl-app-health-checks');
          if (appHealthChecks) data = _objectSpread(_objectSpread({}, data), appHealthChecks);
          break;

        case 'webSiteHealthChecks':
          data.title = t('lbl-web-site-health-checks');
          if (webSiteHealthChecks) data = _objectSpread(_objectSpread({}, data), webSiteHealthChecks);
          break;

        case 'openAPIHealth':
          data.title = t('lbl-supply-data');
          if (openAPIHealth) data = _objectSpread(_objectSpread({}, data), openAPIHealth);
          break;
      }

      return /*#__PURE__*/React.createElement(ServiceMonitorCard, {
        key: item,
        data: data,
        updateTime: moment().format('YYYY-MM-DD'),
        onDialogOpen: function onDialogOpen() {
          if (data.fetchStatus === 'complete') handleOpenDialog(data);
        }
      });
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "service-monitor"
  }, renderServiceMoitorCard(), !_.isEmpty(dialogData) && /*#__PURE__*/React.createElement(ServiceMonitorDialog, {
    data: dialogData,
    onClose: handleCloseDialog
  }));
});
export default ServiceMonitor;